var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overlay" }, [
    _c("div", { staticClass: "overlay__wrapper" }, [
      _c("div", { staticClass: "overlay__content" }, [
        _c(
          "ul",
          {
            staticClass: "modal__content-list modal__content-list--preview",
            attrs: { id: "modal-content" }
          },
          [
            _c(
              "li",
              { staticClass: "modal__content-item modal__content-item--title" },
              [
                _c("span", {
                  staticClass: "modal__title modal__title--preview-success",
                  domProps: {
                    innerHTML: _vm._s(
                      this.config.lang[
                        "modal.control.preview-header-" + this.previewstatus
                      ]
                    )
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "modal__close",
                  on: { click: _vm.jobPreviewClose }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "modal__content-item modal__content-item--preview"
              },
              [
                this.modalmodifier === "errorua"
                  ? _c("div", [
                      _c("h3", {
                        staticClass: "modal__content-preview-subheader",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-subheader-errorua"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "text--content-preview",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorua.par1"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass:
                          "text--content-preview text--content-bold text--content-line",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorua.par2"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "text--content-preview",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorua.par3"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass:
                          "text--content-preview text--content-bold text--content-line",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorua.par4"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "text--content-preview text--content-line",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorua.par5"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "text--content-preview",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorua.par6"
                            ]
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                this.modalmodifier === "errorba"
                  ? _c("div", [
                      _c("h3", {
                        staticClass: "modal__content-preview-subheader",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-subheader-errorba"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "text--content-preview",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorba.par1"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass:
                          "text--content-preview text--content-bold text--content-line",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorba.par2"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "text--content-preview",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorba.par3"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass:
                          "text--content-preview text--content-bold text--content-line",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorba.par4"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "text--content-preview",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.errorba.par5"
                            ]
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                this.modalmodifier === "erroruaba"
                  ? _c("div", [
                      _c("h3", {
                        staticClass: "modal__content-preview-subheader",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-subheader-erroruaba"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "text--content-preview",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.erroruaba.par1"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass:
                          "text--content-preview text--content-bold text--content-line",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.erroruaba.par2"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "text--content-preview",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.erroruaba.par3"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass:
                          "text--content-preview text--content-bold text--content-line",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.erroruaba.par4"
                            ]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "text--content-preview",
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang[
                              "modal.control.preview-text.erroruaba.par5"
                            ]
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "preview__container" }, [
                  _c("div", { staticClass: "preview__slide_container" }, [
                    _c("div", { staticClass: "preview__slide" }, [
                      _c("img", {
                        staticClass: "preview__image",
                        attrs: { src: _vm.imagesource, alt: "Vorschaubild" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.errorUnreadableAdress && !_vm.errorBarcodeArea
                    ? _c("p", { staticClass: "modal__preview-info" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              this.config.lang["modal.control.preview-note"]
                            ) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal__control_action" }, [
                  _vm.errorUnreadableAdress || _vm.errorBarcodeArea
                    ? _c(
                        "div",
                        { staticClass: "modal__control_actionwrapper" },
                        [
                          _vm.errorBarcodeArea
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "modal__control_actionwrapper modal__control_actionwrapper--barcodefixing js-barcode-fixing"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "form__pincheckbox form__pincheckbox--pointer form__pincheckbox--barcodefixing",
                                      attrs: { for: "barcodeFixing" }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.removeBarcode,
                                            expression: "removeBarcode"
                                          }
                                        ],
                                        staticClass: "form__pincheckbox-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: "barcodeFixing",
                                          name: "barcodeFixing",
                                          value: "1"
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.removeBarcode
                                          )
                                            ? _vm._i(_vm.removeBarcode, "1") >
                                              -1
                                            : _vm.removeBarcode
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.removeBarcode,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "1",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.removeBarcode = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.removeBarcode = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.removeBarcode = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "form__pincheckbox-border"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "form__pincheckbox-label"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                this.config.lang[
                                                  "modal.control.preview-deactivate-barcode"
                                                ]
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "form__button form__button-greenandarrow modal__control_submit modal__accept_action modal__accept_action--desktop",
                              attrs: {
                                disabled:
                                  this.modalmodifier === "errorba" &&
                                  !this.removeBarcode
                              },
                              on: { click: _vm.jobPreviewAccept }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    this.config.lang[
                                      "modal.control.preview-accept"
                                    ]
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "form__button form__button-greenandarrow modal__control_submit modal__accept_action modal__accept_action--mobile",
                              attrs: {
                                disabled:
                                  this.modalmodifier === "errorba" &&
                                  !this.removeBarcode
                              },
                              on: { click: _vm.jobPreviewAccept }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    this.config.lang[
                                      "modal.control.preview-accept-mobile"
                                    ]
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "modal__control_cancel modal-close-action modal__error-button modal__delete_action delete__from--warning",
                              on: { click: _vm.jobPreviewDelete }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    this.config.lang[
                                      "modal.control.preview-delete"
                                    ]
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "modal__control_actionwrapper" }, [
                    _c(
                      "a",
                      {
                        staticClass: "modal__control_cancel modal-close-action",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.jobPreviewClose }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              this.config.lang["modal.control.action-cancel"]
                            ) +
                            "\n              "
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }